import store from "../../store";
import BaseHandler from "../BaseHandler";
import { ClientJoinByInviteLinkResponse } from "../../proto/ClientJoinByInviteLink_pb";
import { ClientJoinByUsernameResponse } from "../../proto/ClientJoinByUsername_pb";
import { updateRoomParticipantCount } from "../../store/rooms/actions";

export default class HandleClientJoinResponse extends BaseHandler<ClientJoinByInviteLinkResponse, ClientJoinByUsernameResponse> {
  handle() {
    const clientJoinResponse = this.response?.toObject();
    if (clientJoinResponse) {
      store.dispatch(updateRoomParticipantCount({ value: 1, action: "inc", roomId: clientJoinResponse.roomId }));
    }
  }
}
